import { useState, useEffect, useContext } from 'react'
import { I18nContext } from '../../context/I18nProvider'

import Translate from '../../i18n/Translate'
//Intersection
import { useInView } from 'react-intersection-observer'
//Comps
import ScrollSnap from '../../components/ScrollSnap'
//Img
import testimonial_profile_0 from '../../assets/images/home-foto-testimonios-viajes-profile-tower-Incoming-desk-0.jpg'
import testimonial_profile_0_2x from '../../assets/images/home-foto-testimonios-viajes-profile-tower-Incoming-desk-0@2x.jpg'
import testimonial_profile_1 from '../../assets/images/home-foto-testimonios-viajes-profile-tower-Incoming-desk-1.jpg'
import testimonial_profile_1_2x from '../../assets/images/home-foto-testimonios-viajes-profile-tower-Incoming-desk-1@2x.jpg'
import testimonial_profile_2 from '../../assets/images/home-foto-testimonios-viajes-profile-tower-Incoming-desk-2.jpg'
import testimonial_profile_2_2x from '../../assets/images/home-foto-testimonios-viajes-profile-tower-Incoming-desk-2@2x.jpg'

const Testimonials = () => {
    const { language } = useContext(I18nContext)
    let lang = language.length > 2 ? language.substr(0, 2) : language

    const [testimonials, setTestimonials] = useState([])

    useEffect(() => {
        const testimonialsData = {
            en: [
                {
                    name: 'Joan Cook',
                    testimony:
                        "We had the absolute pleasure of dealing with Tower Incoming on our recent trip to Argentina. It was amazing and I can't recommend them enough. Thank you, Tower!!!",
                    img: testimonial_profile_0,
                    imgx2: testimonial_profile_0_2x,
                },
                {
                    name: 'Lourdes Perez',
                    testimony:
                        'The whole group was happy with the services and attention received. I recommend them 100%.',
                    img: testimonial_profile_1,
                    imgx2: testimonial_profile_1_2x,
                },
                {
                    name: 'Himalee Dilrukshi',
                    testimony:
                        'The service was excellent and will recommend it to my friends. Hope to come back and use the same service.',
                    img: testimonial_profile_2,
                    imgx2: testimonial_profile_2_2x,
                },
            ],
            es: [
                {
                    name: 'Joan Cook',
                    testimony:
                        'Tuvimos el placer absoluto de tratar con Tower Incoming en nuestro reciente viaje a Argentina. Fue increíble y no puedo recomendarlos lo suficiente. Gracias Tower!!!',
                    img: testimonial_profile_0,
                    imgx2: testimonial_profile_0_2x,
                },
                {
                    name: 'Lourdes Perez',
                    testimony:
                        'Todo el grupo quedo feliz con los servicios y atenciones recibidos. Los recomiendo 100%.',
                    img: testimonial_profile_1,
                    imgx2: testimonial_profile_1_2x,
                },
                {
                    name: 'Himalee Dilrukshi',
                    testimony:
                        'El servicio fue excelente y se lo recomendaré a mis amigos. Espero volver y utilizar el mismo servicio.',
                    img: testimonial_profile_2,
                    imgx2: testimonial_profile_2_2x,
                },
            ],
            pt: [
                {
                    name: 'Joan Cook',
                    testimony:
                        'Tivemos o prazer absoluto de lidar com a Tower Incoming em nossa recente viagem à Argentina. Foi incrível e não posso recomendá-los o suficiente. Obrigada Tower!!!',
                    img: testimonial_profile_0,
                    imgx2: testimonial_profile_0_2x,
                },
                {
                    name: 'Lourdes Perez',
                    testimony:
                        'Todo o grupo ficou satisfeito com os serviços e atenção recebidos. Eu os recomendo 100%.',
                    img: testimonial_profile_1,
                    imgx2: testimonial_profile_1_2x,
                },
                {
                    name: 'Himalee Dilrukshi',
                    testimony:
                        'O serviço foi excelente e recomendo aos meus amigos. Espero voltar e usar o mesmo serviço.',
                    img: testimonial_profile_2,
                    imgx2: testimonial_profile_2_2x,
                },
            ],
        }
        setTestimonials(testimonialsData[lang])
    }, [lang])

    const [cardsContainerRef, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <section className="incoming-home__testimonials">
            {testimonials.length > 0 && (
                <>
                    <h2>
                        <Translate langkey="home.testimonials.title" />
                    </h2>

                    <div
                        className={`testimonials-cards-container animate slide-up-steps ${inView ? 'in-view' : ''}`}
                        ref={cardsContainerRef}
                    >
                        <ScrollSnap
                            type="mandatory"
                            columnGap="16"
                            columnGapDt="16"
                            columnGapDtLarge="20"
                            autoSlide={6000}
                            align="start"
                        >
                            {testimonials.map(({ name, testimony, img, imgx2 }, index) => (
                                <div className="testimonial-card" key={index}>
                                    <div className="profile-pic-wrapper">
                                        <img src={img} srcSet={`${img} 1x,${imgx2} 2x, ${imgx2} 3x`} alt={name} />
                                    </div>
                                    <h4>{name}</h4>
                                    <p>{testimony}</p>
                                    <div className="lying-triangle"></div>
                                </div>
                            ))}
                        </ScrollSnap>
                    </div>
                </>
            )}
        </section>
    )
}

export default Testimonials
